var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.10047,
    height: 31.35408,
    viewBox: "0 0 66.10047 31.35408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d0cfce;}.cls-2{fill:#3f3f3f;}.cls-3{stroke:#000;}.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4{stroke:#ea5a47;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-supplement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xx",
    className: "cls-3",
    d: "M11.7,21.85408s14.4-2.1,49.4-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.2,1.05408S35.5,.05408,25.4,6.65408,9.2,18.35408,9.2,18.35408c0,0-1.8,1.8-1.9,3.9-.2,3,6.9,3.9,6.9,3.9l15.4,1.1h35.5s-.2-26.2,0-26.2c.1,0-15.9,0-15.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.4,12.45408l3,3H62.1v-7c0-.6-.4-1-1-1h-19s-8.6-.2-18.1,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.7,21.85408s14.4-2.1,49.4-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 28.35408,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 28.35408,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 30.35408,
    x2: 64.1,
    y2: 30.35408
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.2,1.05408S35.5,.05408,25.4,6.65408,9.2,18.35408,9.2,18.35408c0,0-1.8,1.8-1.9,3.9-.2,3,6.9,3.9,6.9,3.9l15.4,1.1h35.5s-.2-26.2,0-26.2c.1,0-15.9,0-15.9,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "24.4 12.45408 27.4 15.55408 61.1 15.55408"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.1520e59bec406b32afb4a8520a58f0c2.svg";
export { ForwardRef as ReactComponent };